/** Ekranlar arası veri değişikliği bildirimi (kayıt formu kaydedince liste sekmesi yenilenir) */
const EVT = 'dolphin:data-changed';
export function notifyDataChanged(tag: number) {
  window.dispatchEvent(new CustomEvent(EVT, { detail: { tag } }));
}
export function onDataChanged(fn: (tag: number) => void) {
  const h = (e: Event) => fn((e as CustomEvent).detail?.tag);
  window.addEventListener(EVT, h);
  return () => window.removeEventListener(EVT, h);
}
